import { Outlet } from 'react-router-dom';
import { CustomContentProvider } from '../contexts/CustomContentContext';

/**
 * Wrapper component that provides CustomContentContext to custom content routes
 * This ensures CustomContentContext is only accessible to content management pages
 */
export function CustomContentRoutes() {
  return (
    <CustomContentProvider>
      <Outlet />
    </CustomContentProvider>
  );
}

